var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('layout-form',[_c('select-collection'),_c('input-fields')],1)}
var staticRenderFns = []

export { render, staticRenderFns }